import React, { useState } from "react";

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(0); // First FAQ open by default

  const faqData = [
    {
      question: "What services do you offer?",
      answer:
        "Hope Web Solution provides a complete range of IT and digital services including website design, web development, mobile app development, e-commerce solutions, SEO, branding, UI/UX design, and ongoing technical support.",
    },
    {
      question: "Which industries do you work with?",
      answer:
        "We work with multiple industries such as healthcare, education, finance, real estate, retail, IT startups, and small businesses.",
    },
    {
      question: "How do you determine project pricing?",
      answer:
        "Our pricing depends on the project scope, features, technology stack, and timeline. We provide a free consultation to understand your requirements and share a detailed quotation.",
    },
    {
      question: "How long does it take to complete a project?",
      answer:
        "The project timeline depends on the complexity, features, and design requirements. After understanding your project, we share a clear timeline during the consultation.",
    },
    {
      question: "What are your payment terms?",
      answer:
        "We follow milestone-based payment terms. A project typically starts with an upfront payment, followed by payments at various development stages.",
    },
    {
      question: "Do you offer post-launch support?",
      answer:
        "Yes, we provide technical support, website maintenance, updates, security monitoring, and performance optimization after the project is completed.",
    },
    {
      question: "What is your refund policy?",
      answer:
        "Refunds are considered only if the project has not been started or in special cases based on mutual agreement. All terms are clearly discussed during the project onboarding.",
    },
  ];

  return (
    <section className="faq">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-8 col-md-12 text-center">
            <h2 className="title">Frequently Asked Questions</h2>
            <span className="label">
              Here’s a glimpse of what we’ve accomplished through dedication,
              innovation, and teamwork. Don’t just take our word for it —
              explore our work and see the results for yourself.
            </span>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-12">
            <div className="accordion">
              {/* 👉 Accordion Loop */}
              {faqData.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    className={`accordion-item ${isOpen ? "active" : ""}`}
                    key={index}
                  >
                    <button
                      id={`accordion-button-${index + 1}`}
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className={isOpen ? "active" : ""}
                    >
                      <span className="accordion-title">{item.question}</span>
                      <span
                        className={`icon ${isOpen ? "open" : ""}`}
                        aria-hidden="true"
                      ></span>
                    </button>
                    <div
                      className={`accordion-content ${isOpen ? "active" : ""}`}
                    >
                      <p>{item.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
